import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/fails.js";
import { i as a } from "../internals/is-array.js";
import { i as s } from "../internals/is-object.js";
import { t as e } from "../internals/to-object.js";
import { l as o } from "../internals/length-of-array-like.js";
import { d as n } from "../internals/does-not-exceed-safe-integer.js";
import { c as i } from "../internals/create-property.js";
import { a as m } from "../internals/array-species-create.js";
import { a as f } from "../internals/array-method-has-species-support.js";
import { w as l } from "../internals/well-known-symbol.js";
import { e as p } from "../internals/engine-v8-version.js";
var c = l("isConcatSpreadable"),
  j = p >= 51 || !t(function () {
    var r = [];
    return r[c] = !1, r.concat()[0] !== r;
  }),
  u = function u(r) {
    if (!s(r)) return !1;
    var t = r[c];
    return void 0 !== t ? !!t : a(r);
  };
r({
  target: "Array",
  proto: !0,
  arity: 1,
  forced: !j || !f("concat")
}, {
  concat: function concat(r) {
    var t,
      a,
      s,
      f,
      l,
      p = e(this),
      c = m(p, 0),
      j = 0;
    for (t = -1, s = arguments.length; t < s; t++) if (l = -1 === t ? p : arguments[t], u(l)) for (n(j + (f = o(l))), a = 0; a < f; a++, j++) a in l && i(c, j, l[a]);else n(j + 1), i(c, j++, l);
    return c.length = j, c;
  }
});